import React, { useEffect, useState } from "react";
import ServiceCard from "./ServiceCard";
import { staticServicesData } from "./data";
import Loader from "../../../../common/Loader";
import api from "../../../../configs/api";

export default function Services() {

  const [servicesData, setServicesData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const setHeroDataFn = async () => {
    try {
      const servicesData = await api.get("/CMS/home-services");
      setServicesData(servicesData.data);
      setIsLoading(false);
    } catch (error) {
      console.error("set theme error: ", error);
      setServicesData(staticServicesData);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setHeroDataFn();
  }, []);

  return (
    <section className='mb-32 px-10'>
      <h2 className='text-6xl font-custom-600 mb-[7rem] text-center'>
        الخدمات
      </h2>
      <div className='flex flex-wrap gap-14 justify-center'>
        {isLoading ? (
          <div className='flex justify-center items-center'>
            <Loader isFullScreen={false} />
          </div>
        ) : (
          <>
            {servicesData?.map((item, index) => (
              <React.Fragment key={item.title + index}>
                <ServiceCard index={index} {...item} />
              </React.Fragment>
            ))}
          </>
        )}
      </div>
    </section>
  );
}
